import type { EventContentObjectList } from 'models';
import { useCallback, useMemo } from 'react';
import { useConfirmDelete } from '../../../hooks';
import { useDeleteEventContentObjectMutation } from '../../../queries';

export const useDeleteEventConfirmModal = () => {
  const { mutateAsync: deleteEvent } = useDeleteEventContentObjectMutation();
  const { confirm, contextHolder } = useConfirmDelete();

  const confirmDelete = useCallback(
    ({ item, onSuccess, title }: { item: EventContentObjectList; onSuccess: () => void; title: string }) => {
      confirm({
        async onOk() {
          await deleteEvent(
            { contentObject: item },
            {
              onSuccess,
            },
          );
        },
        title,
      });
    },
    [confirm, deleteEvent],
  );

  return useMemo(
    () => ({
      confirm: confirmDelete,
      contextHolder,
    }),
    [confirmDelete, contextHolder],
  );
};
